var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleMas1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90248 4.6292C10.366 4.6292 11.6899 5.3697 12.4487 6.39005L14.247 4.60416C13.1715 3.22511 11.1014 2.13159 8.90248 2.13159C5.05236 2.13159 1.89453 5.20368 1.89453 9.00001C1.89453 12.7963 5.05236 15.8684 8.90248 15.8684C12.0941 15.8684 14.779 13.758 15.6022 10.8732C15.7795 10.2737 15.8682 9.64929 15.8682 9.00001V8.37561H9.53573V10.8727H12.8919C12.1954 12.3464 10.6629 13.3708 8.90248 13.3708C6.45821 13.3708 4.42753 11.4101 4.42753 9.00001C4.42753 6.58989 6.45821 4.6292 8.90248 4.6292Z",
    fill: "#2D3035"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMas1);
export default __webpack_public_path__ + "static/media/google-mas 1.859e5c27bbd6a3a3c0567a725a007179.svg";
export { ForwardRef as ReactComponent };